import { PricingPlan } from '@/constants/enum';
import { apiCaller } from '@/redux/query';

export const useUserPlan = () => {
  const { data } = apiCaller.useGeneralSettingsQuery();
  const plan = data?.data?.plan;
  const isLimitedFormAnswer = plan === PricingPlan.Free || plan === PricingPlan.Basic;
  return { plan, isLimitedFormAnswer };
};
